/**
 * Calculate the distance between two points in kilometers
 * https://stackoverflow.com/a/27943/1477578
 *
 */
export default function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const deg2rad = (deg) => deg * Math.PI / 180;
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a = (
    0.5 - Math.cos(dLat) / 2 +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    (1 - Math.cos(dLon)) / 2
  );

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
